import { useSelector } from 'react-redux';
import { AppState } from '../reducers';

export const useIsAuthenticated = () => {
  return useSelector((state: AppState) => state.areas.account.isAuthenticated);
};
